<template>
  <div :class="[jobColor,'case']">
    <div class="profile">
      <img :src="profileImg" alt="">
      <div class="link">
        <router-link :to="link">
          社員紹介はコチラ
          <KurehaArrow class="kureha_arrow" :width="150" />
        </router-link>
      </div>
    </div>
    <div class="figure">
      <picture>
        <source :srcset="caseImg"
                media="(min-width: 768px)">
        <source :srcset="caseImgSp"
                media="(max-width: 767px)">
        <img :src="caseImg" alt="" />
      </picture>
    </div>
  </div>
</template>

<script>
import KurehaArrow from "@/components/icons/KurehaArrow.vue"
export default {
  name: "case",
  components: {
    KurehaArrow
  },
  props: {
    jobColor: {
      type: String,
      default: 'light_green'
    },
    profileImg: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: "/"
    },
    caseImg: {
      type: String,
      default: ""
    },
    caseImgSp: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.case {
  max-width: 840px;
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  position: relative;
  @media print,screen and (max-width: 1000px) {
    margin-top: 50px;
  }
  &.light_green {
    .link a {
      border: 2px solid #3fae00;
      color: #3fae00;
    }
  }
  &.dark_green {
    .link a {
      border: 2px solid #00797f;
      color: #00797f;
    }
  }
}
.profile {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  @media print,screen and (max-width: 1000px) {
    flex-direction: column;
  }
  img {
    max-height: 180px;
  }
}
.link {
  position: relative;
  font-weight: bold;
  font-size: 16px;
  margin: 50px 0;
  a {
    display: block;
    border-radius: 30px;
    padding: 5px 60px 5px 30px;
  }
}
::v-deep .kureha_arrow {
  right: -30px;
  left: auto;
  top: 10px;
  margin: auto;
  width: 75px;
}
.figure {
  text-align: center;
}
</style>